import { Injectable } from '@angular/core';
import { ConfigMeta } from '../../models/meta';
import { ConfigurationService } from '../configuration/configuration.service';
import { ActivatedRoute, QueryParamsHandling } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GestionProvenanceService {
  libelleProvenance: BehaviorSubject<string> = new BehaviorSubject<string>('caad.button.retour');

  constructor(
    private readonly configurationService: ConfigurationService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly translateService: TranslateService
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      const provenanceValue = params['provenance'];
      if (provenanceValue) {
        this.translateService.get(`caad.provenance.${provenanceValue}`).subscribe((translation: string) => {
          if (translation && translation !== `caad.provenance.${provenanceValue}`) {
            this.libelleProvenance.next(`caad.provenance.${provenanceValue}`);
          } else {
            this.libelleProvenance.next('caad.button.retour');
          }
        });
      }
    });
  }

  obtenirRouteExterne(): string | null {
    return this.configurationService.getValueOrNull(ConfigMeta.OEL_URL_RETOUR_EXTERNE);
  }

  estProvenanceExterne(): boolean {
    const routeExterne = this.obtenirRouteExterne();
    return routeExterne !== null && routeExterne.trim().length > 0;
  }

  obtenirValeurQueryParamsHandling(): QueryParamsHandling | null {
    if (this.estProvenanceExterne()) {
      return 'merge';
    }
    return null;
  }

  obtenirLibelleProvenance(): BehaviorSubject<string> {
    return this.libelleProvenance;
  }
}
